import { render, staticRenderFns } from "./ProjectListDoc.vue?vue&type=template&id=7098c89f&scoped=true"
import script from "./ProjectListDoc.vue?vue&type=script&lang=js"
export * from "./ProjectListDoc.vue?vue&type=script&lang=js"
import style0 from "./ProjectListDoc.vue?vue&type=style&index=0&id=7098c89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7098c89f",
  null
  
)

export default component.exports